import React, { useContext, useState } from 'react';
import { View } from 'react-native';
import { Button, CheckBox, Input } from '@rneui/themed';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import Styles from './styles';
import { post } from '../../../../common/Api';
import AppContext from '../../../../contexts/App';
import RegistrationContext, { Actions } from '../../../../contexts/Registration';

const RegistrationStep3 = ({ control, getValues, setError }) => {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(RegistrationContext);
    const [authroized, setAuthorized] = useState(false);

    const handleSendTextConfirmation = async () => {
        const mobileNumber = getValues('mobileNumber');

        if (mobileNumber) {
            const endpoint = `${state.settings.openIdSettings.authority}/Account/SendVerificationText?phone=${mobileNumber}`;
            const response = await post(endpoint);

            if (response?.success) {
                dispatch({
                    type: Actions.SET_MOBILE_CONFIRM_ID,
                    mobileConfirmationId: response.confirmationCodeId
                });
            } else {
                setError('mobileConfirmationCode', {
                    type: 'custom',
                    message: 'Code does not match our records, please make sure you entered it correctly.'
                });
            }
        }
    };

    return (
        <View style={{ width: '100%' }} testID='Registration.Step3'>
            <View style={{ flexDirection: 'row', width: '100%' }}>
                <Controller
                    control={control}
                    defaultValue=''
                    name='mobileNumber'
                    render={({ field, fieldState }) => {
                        return (
                            <Input
                                {...field}
                                containerStyle={{ width: '100%', marginVertical: 20 }}
                                errorMessage={!fieldState.error ? 'MOBILE PHONE (OPTIONAL) ' : fieldState.error?.message}
                                errorStyle={!fieldState.error ? Styles.placeholderStyle : Styles.errorStyle}
                                innerRef={field.ref}
                                inputStyle={Styles.smallInputStyle}
                                onChangeText={val => field.onChange(val)}
                                textContentType='telephoneNumber'
                                spellCheck={false}
                            />
                        );
                    }}
                />
            </View>
            <CheckBox
                center={true}
                checked={authroized}
                checkedColor='#a61a2b'
                containerStyle={Styles.checkboxContainer}
                textStyle={Styles.checkboxText}
                //
                // title will be needed to come from Umbraco
                //
                title='I authorize Hagee Ministries to send messages to the mobile number provided above. I understand that message & data rates may apply.'
                onIconPress={() => setAuthorized(current => !current)}
            />
            <View style={{ alignContent: 'space-between', width: '100%' }}>
                <Button
                    buttonStyle={Styles.stepButton}
                    containerStyle={Styles.stepButtonContainer}
                    disabled={!authroized}
                    disabledStyle={Styles.disabledStepButton}
                    disabledTitleStyle={Styles.disabledStepButtonTitle}
                    onPress={() => handleSendTextConfirmation()}
                    title='NEXT STEP'
                    titleStyle={Styles.stepButtonTitle}
                    type='solid'
                />
                <Button
                    buttonStyle={Styles.stepButton}
                    containerStyle={Styles.stepButtonContainer}
                    disabledStyle={Styles.disabledStepButton}
                    disabledTitleStyle={Styles.disabledStepButtonTitle}
                    onPress={() => dispatch({ type: Actions.SKIP })}
                    title='Skip'
                    titleStyle={Styles.stepButtonTitle}
                    type='solid'
                />
            </View>
        </View>
    );
};

RegistrationStep3.propTypes = {
    control: PropTypes.object.isRequired,
    getValues: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired
};

export default RegistrationStep3;
